<template>
  <div id="survey-links-home">
    <BreadcrumbsNav />

    <v-card elevation="0" class="text-center text-md-left mb-10">
      <v-row v-if="$vuetify.breakpoint.smAndDown">
        <v-col cols="12">
          <v-img max-height="100px" contain src="/static/images/lighthouse.png" alt=""></v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="3" md="3" v-if="$vuetify.breakpoint.mdAndUp">
          <v-img max-height="200px" contain src="/static/images/lighthouse.png" alt=""></v-img>
        </v-col>
        <v-col cols="12" sm="9" md="4">
          <v-card-title class="pr-0">
            <h1 class="font-weight-black text-h5 text-sm-h4">
              Aidez-nous à gaspiller moins et à vous régaler davantage en donnant votre avis sur vos passages dans nos
              restaurants
            </h1>
          </v-card-title>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-card>

    <!-- Recherche + liste + pagination : extraites en panneau pour être réutilisées
         hors de cette page (card modale « Mes avis » du dashboard convive). -->
    <SurveyLinksPanel />
  </div>
</template>

<script>
import BreadcrumbsNav from "@/components/BreadcrumbsNav.vue"
import SurveyLinksPanel from "./SurveyLinksPanel.vue"

export default {
  name: "SurveyLinksHome",
  components: { BreadcrumbsNav, SurveyLinksPanel },
}
</script>
